import { motion } from "framer-motion";

export const Intro = () => (
  <section
    id="intro"
    data-testid="intro-section"
    className="bg-[#050505] px-5 py-24 sm:px-10 sm:py-36 lg:py-44"
  >
    <div className="mx-auto max-w-7xl">
      <motion.span
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="mb-8 block font-mono text-[10px] uppercase tracking-[0.35em] text-[#8E8E93] sm:text-xs"
      >
        01 — THE IDEA
      </motion.span>

      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="font-display text-[clamp(3rem,9vw,8.5rem)] font-black uppercase leading-[0.9] tracking-tight text-[#F3F3F5]"
      >
        I EDIT <span className="text-[#E63946]">REAL LIFE.</span>
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.15 }}
        className="mt-10 max-w-2xl text-lg text-[#F3F3F5] sm:text-xl"
      >
        You already have the footage. My job is finding the story inside it.
      </motion.p>

      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.25 }}
        className="mt-6 max-w-2xl text-sm leading-relaxed text-[#8E8E93] sm:text-base"
      >
        JW. EDITS takes ordinary phone footage — outings, performances, celebrations,
        behind-the-scenes moments, business content, and everyday experiences — and turns it
        into polished social videos. No professional cameras. No giant production. Send the
        footage you already have, and it comes back as something worth replaying.
      </motion.p>
    </div>
  </section>
);
